// src/services/paymentService.js
// ─────────────────────────────────────────────────────────────────
// NOTE: Install the qrcode package for KHQRDisplay component:
//   npm install qrcode
//
// This service calls Firebase Cloud Functions for payment operations.

import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

const createOrderFn = httpsCallable(functions, "createOrder");
const checkStatusFn = httpsCallable(functions, "checkPaymentStatus");

/**
 * Initiate a purchase — calls Cloud Function to create order & get KHQR.
 *
 * @param {string} gameId
 * @returns {{ orderId, qrCodeData, amount, gameTitle, expiresAt }}
 */
export async function initiatePayment(gameId) {
  const result = await createOrderFn({ gameId });
  return result.data;
}

/**
 * Poll for payment status.
 * Call this every 3 seconds while showing the QR code.
 *
 * @param {string} orderId
 * @returns {{ status, credentials?, orderId, gameTitle, amount }}
 */
export async function pollPaymentStatus(orderId) {
  const result = await checkStatusFn({ orderId });
  return result.data;
}